import { render, staticRenderFns } from "./ClearUser.vue?vue&type=template&id=5d951000&scoped=true"
import script from "./ClearUser.vue?vue&type=script&lang=js"
export * from "./ClearUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d951000",
  null
  
)

export default component.exports